
<template>
  <modal @close="close" width="90%">
    <md-toolbar :class="headerClass" md-elevation="1" slot="header">
      <h3 class="text-center md-title">
        <md-icon>
          {{ realPlan.planExpected.status | planIcon }}
        </md-icon>
        Generadores | {{ realPlan.planExpected.sinisterNumber }} |
        {{ hasRequiredPhotos | statusMessage }}
      </h3>
    </md-toolbar>

    <generators
      slot="body"
      :affectedId="affectedId"
      :is-extranet="isExtranet"
      :realPlan="realPlan"
      :check-date="realPlan.date"
      v-if="affectedId"
      :read-only="realPlan.readOnly || isExtranet"
      :isES="true"
      :isCP="true"
      :work-plan-id="realPlan.planExpectedId"
      @hasRequiredPhotos="hasRequiredPhotos = $event"
    />

    <md-button @click="close" slot="footer"> Cancelar </md-button>
  </modal>
</template>

<script>
import { TASK_STATUS_ICONS } from "./utils";
import Generators from "./../Generators.vue";

export default {
  name: "GeneratorsModal",

  props: {
    realPlan: {
      type: Object,
      required: true
    },
    isExtranet: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    sinisterId() {
      const realPlan = this.realPlan;
      const planExpected = realPlan && realPlan.planExpected;
      return planExpected && planExpected.sinisterId;
    },
    affectedId() {
      const realPlan = this.realPlan;
      const planExpected = realPlan && realPlan.planExpected;
      return planExpected && planExpected.affectedId;
    },
    headerClass() {
      const { hasRequiredPhotos } = this;
      if (hasRequiredPhotos) {
        return "md-success";
      } else if (hasRequiredPhotos === false) {
        return "md-warning";
      }
    }
  },

  components: {
    Generators
  },

  methods: {
    close() {
      this.$emit("close");
    },
    downloadWorkGenerator(qId, type) {
      purchaseService
        .getWorkGenerator(qId, type)
        .then(() => (this.$successMessage({ title:`Archivo descargado` })))
        .catch(this.$fireErrorResponse)
    }
  },

  data() {
    return {
      hasRequiredPhotos: false
    };
  },

  filters: {
    planIcon(status) {
      return TASK_STATUS_ICONS[status] || "visibility";
    },
    statusMessage(evidencesStatus) {
      if (evidencesStatus) {
        return "Tiene todos los archivos";
      } else if (evidencesStatus === false) {
        return "Faltan archivos";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/GeneratorModal.vue